import {fetch} from '@app/apiFunction';
import {BASE_URL} from '../config';

export const archivesFilter = (data: any) => {
  const filtered = data.filter((todo: any) => todo.isArchived === true);
  return filtered;
};

export const unArchivesFilter = (data: any) => {
  const filtered = data.filter((todo: any) => todo.isArchived === false);
  return filtered;
};

export const getAllTodos = async (query: any) => {
  var requestQuery = '';

  if (query) {
    var requestQuery = Object.keys(query)
      .filter((v) => {
        return query[v] !== null;
      })
      .filter((v) => query[v] !== 0)
      .filter((v) => query[v] !== '')
      .map((v) => {
        return `${v}=${query[v]}`;
      })
      .join('&');
  }
  const finalRequestQuery = requestQuery.replace(/\s/g, '');
  const url = `${BASE_URL}/todos/get-all-todos?${finalRequestQuery}`;
  const token = localStorage.getItem('token');
  const type = 'get';
  const resp = await fetch(url, type, null, token);

  return resp;
};

const dashToSlash = (data: any) => {
  if (data.expiryDate !== undefined || data.expiryDate !== '') {
    const splitted = data.expiryDate.split('-');
    const modified = `${splitted[2]}/${splitted[1]}/${splitted[0]}`;
    data.expiryDate = modified;
  }
  return data;
};

export const createTodo = async (body: any) => {
  const modifiedValues = dashToSlash(body);
  const token = localStorage.getItem('token');
  const method = 'post';
  const url = `${BASE_URL}/todos/create`;
  const payload = JSON.stringify(modifiedValues);
  const req = await fetch(url, method, payload, token);
  return req;
};

export const getTodoById = async (id: any) => {
  const token = localStorage.getItem('token');
  const method = 'GET';
  const url = `${BASE_URL}/todos/${id}`;
  const payload = null;
  const req = await fetch(url, method, payload, token);
  return req;
};

export const indexHandler = (arr: any, id: any) => {
  const result = Array.from(arr);
  const filtered = result.filter((item: any) => item._id !== id);
  return filtered;
};

const slashToDash = (data: any) => {
  if (data.expiryDate !== undefined || data.expiryDate !== '') {
    const splitted = data.expiryDate.split('-');
    const modified = `${splitted[2]}/${splitted[1]}/${splitted[0]}`;
    data.expiryDate = modified;
  }
  return data;
};

export const updateTodo = async (body: any, id: any) => {
  const modifiedValues = slashToDash(body);
  const url = `${BASE_URL}/todos/update/${id}`;
  const method = 'POST';
  const payload = JSON.stringify(modifiedValues);
  const token = localStorage.getItem('token');
  const resp = await fetch(url, method, payload, token);
  return resp;
};

export const archiveTodo = async (id: any) => {
  const url = `${BASE_URL}/todos/is-archieved/${id}`;
  const method = 'POST';
  const payload = JSON.stringify({isArchieved: true});
  const token = localStorage.getItem('token');
  const resp = await fetch(url, method, payload, token);
  return resp;
};

export const unArchiveTodo = async (id: any) => {
  const url = `${BASE_URL}/todos/is-archieved/${id}`;
  const method = 'POST';
  const payload = JSON.stringify({isArchieved: false});
  const token = localStorage.getItem('token');
  const resp = await fetch(url, method, payload, token);
  return resp;
};

export const errorModifier = (text: any) => {
  if (text.includes('text')) {
    return text.replace('text', 'Text');
  }

  if (text.includes('priority')) {
    return text.replace('priority', 'Priority');
  }
  if (text.includes('expiryDate')) {
    return text.replace('expiryDate', 'Expiry date');
  }
};
